import type { paths } from '@orlikfy/api-interfaces';

// POST /contact/message
export const CREATE_CONTACT_MESSAGE_PATH = '/contact/message' as const satisfies keyof paths;
type CreateContactMessageOperation = paths[typeof CREATE_CONTACT_MESSAGE_PATH]['post'];
export type CreateContactMessageBody = CreateContactMessageOperation['requestBody']['content']['application/json'];
